import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { Navbar, Nav, Button } from "react-bootstrap";
import AuthContext from '../../context/AuthContext';

export default function Header(props) {
	let { userDetails, onPressLogout } = useContext(AuthContext);

	return (
		<Navbar bg="steel" expand="md" fixed="top" variant="dark">
			<Navbar.Brand className='mr-4' as={Link} to="/">{props.applicationName}</Navbar.Brand>
			<Navbar.Toggle aria-controls="navbar-nav-vision" />
			<Navbar.Collapse id="navbar-nav-vision">
				{userDetails?.is_authenticated ? (
					<>
						<Nav className="me-auto">
							{userDetails.user_type === "A" ? (
								<>
									<Nav.Link as={Link} to="/clinic/new" className="d-none d-sm-block">New Clinic</Nav.Link>
									<Nav.Link as={Link} to="/clinic">Clinic Details</Nav.Link>
									<Nav.Link as={Link} to="/demo-request">Demo Requestor Details</Nav.Link>
								</>
							) : null}
						</Nav>
						<Nav className="ml-auto">
							<Nav.Link as={Link} to='#'>{userDetails.user_name}</Nav.Link>
							<Nav.Link as={Button} to="#" onClick={onPressLogout}>Logout</Nav.Link>
						</Nav>
					</>
				) : (<> </>)}
			</Navbar.Collapse>
		</Navbar>
	);
}
